import React, { FC, ReactNode } from 'react';

export const TABLE_HEIGHT = 480;

export const dataTableThClass =
  'py-3.5 px-4 text-xs font-semibold uppercase tracking-wider text-slate-500 border-b border-slate-200 bg-slate-50 whitespace-nowrap';

export const dataTableTdClass =
  'py-3.5 px-4 text-sm text-slate-700 border-b border-slate-100';

export const dataTableRowClass =
  'hover:bg-[#086DE1]/[0.04] transition-colors even:bg-slate-50/60';

export const searchInputClass =
  'w-full px-4 py-2 pr-20 border border-slate-200 rounded-xl bg-slate-50/50 text-sm text-slate-800 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-[#086DE1]/25 focus:border-[#086DE1] focus:bg-white transition-all';

interface DataTableProps {
  children: ReactNode;
  footer?: ReactNode;
  height?: number;
}

const DataTable: FC<DataTableProps> = ({ children, footer, height = TABLE_HEIGHT }) => {
  return (
    <div className="flex flex-col rounded-xl border border-slate-200 bg-white shadow-sm overflow-hidden">
      <div className="overflow-auto" style={{ height: `${height}px` }}>
        {children}
      </div>
      {footer && (
        <div className="shrink-0 border-t border-slate-200 bg-slate-50 px-4 py-3">
          {footer}
        </div>
      )}
    </div>
  );
};

export default DataTable;
